import { MsalAuthProvider, LoginType } from "react-aad-msal";

const config = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || "",
    authority:
      "https://login.microsoftonline.com/" + process.env.REACT_APP_TENANT_ID ||
      "",
    redirectUri: process.env.REACT_APP_DEPLOYE_URL,
    postLogoutRedirectUri: process.env.REACT_APP_DEPLOYE_URL,
    validateAuthority: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
};

export const authenticationParameters = {
  scopes: ["user.read", "email", "openid"],
};

const options = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: window.location.origin,
};

export const authProvider = new MsalAuthProvider(
  config,
  authenticationParameters,
  options,
);
